import { Component } from '@angular/core';

@Component({
  selector: 'app-splash-screen',
  standalone: false,
  // imports: [],
  templateUrl: './splash-screen.component.html',
  styleUrl: './splash-screen.component.scss'
})
export class SplashScreenComponent {

}
